import $ from '@rover/globals/jquery';
import ModalView from '../components/rover_modal';

$(() => {
  $('a.sadsal_terms-and-conditions-link').on('click', () => {
    new ModalView({
      title: 'Terms & Conditions',
      content:
        '<p>If you choose to donate, the percentage you specify will be deducted from your earnings on each booking you complete. You’ll see this come through as part of Rover’s take rate. Rover will then make the donation on your behalf.</p>' +
        '<p>You won’t be taxed for making donations. Your 1099 income will be less the amount you’ve donated.</p>' +
        '<p>Donations made through Sit a Dog, Save a Life are not tax deductible because they are not included in your reported income.</p>',
      showFooter: false,
      cancelText: null,
      okText: null,
      applyScrollFix: false,
    }).open();
  });
});



// WEBPACK FOOTER //
// ./js/plugins/sadsal.js